import { Center } from '@zorro/web/design-system';
import React from 'react';

import { SVGIconProps } from '../types';

type Props = {
  style?: SVGIconProps;
  className?: string;
};
export const OnExchangeIcon = ({ style, className }: Props) => {
  return (
    <Center style={style} className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
      >
        <path
          d="M2.90625 14.5339H15.0938M2.90625 5.05477V5.73185C2.90625 6.27057 3.12026 6.78723 3.50119 7.16816C3.88212 7.5491 4.39878 7.7631 4.9375 7.7631C5.47622 7.7631 5.99288 7.5491 6.37381 7.16816C6.75474 6.78723 6.96875 6.27057 6.96875 5.73185M2.90625 5.05477H15.0938M2.90625 5.05477L4.26042 2.34644H13.7396L15.0938 5.05477M6.96875 5.73185V5.05477M6.96875 5.73185C6.96875 6.27057 7.18276 6.78723 7.56369 7.16816C7.94462 7.5491 8.46128 7.7631 9 7.7631C9.53872 7.7631 10.0554 7.5491 10.4363 7.16816C10.8172 6.78723 11.0312 6.27057 11.0312 5.73185M11.0312 5.73185V5.05477M11.0312 5.73185C11.0312 6.27057 11.2453 6.78723 11.6262 7.16816C12.0071 7.5491 12.5238 7.7631 13.0625 7.7631C13.6012 7.7631 14.1179 7.5491 14.4988 7.16816C14.8797 6.78723 15.0937 6.27057 15.0938 5.73185V5.05477M4.26042 14.534V7.66161M13.7396 14.534V7.66161M6.96875 14.5339V11.8256C6.96875 11.4665 7.11142 11.122 7.36538 10.8681C7.61933 10.6141 7.96377 10.4714 8.32292 10.4714H9.67708C10.0362 10.4714 10.3807 10.6141 10.6346 10.8681C10.8886 11.122 11.0312 11.4665 11.0312 11.8256V14.5339"
          stroke="#1A1721"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Center>
  );
};
